// Privacy Notice Modal Component
import React, { useState, useEffect } from 'react';
import privacyService from '../services/privacyService';
import './PrivacyNoticeModal.css';

const PrivacyNoticeModal = ({ 
  isOpen, 
  onClose, 
  onAccept, 
  institution = '',
  showAcceptButton = true 
}) => {
  const [privacyData, setPrivacyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      loadPrivacyNotice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, institution]);

  const loadPrivacyNotice = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await privacyService.getPrivacyNotice(institution);
      setPrivacyData(data);
    } catch (err) {
      setError('Error al cargar el aviso de privacidad');
      console.error('Error loading privacy notice:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleAccept = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onAccept) {
      onAccept();
    }
    // No llamar onClose() aquí, lo maneja el componente padre
  };

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="privacy-modal-overlay" onClick={handleBackdropClick}>
      <div className="privacy-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-modal-header">
          <h2 className="privacy-modal-title">
            {privacyData?.title || 'Aviso de Privacidad'}
          </h2>
          <button 
            className="privacy-modal-close" 
            onClick={onClose}
            aria-label="Cerrar"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className="privacy-modal-body">
          {loading && (
            <div className="privacy-loading">
              <div className="privacy-spinner"></div>
              <p>Cargando aviso de privacidad...</p>
            </div>
          )}

          {error && (
            <div className="privacy-error">
              <p>⚠️ {error}</p>
              <button onClick={loadPrivacyNotice} className="retry-button">
                Reintentar
              </button>
            </div>
          )}

          {privacyData && !loading && (
            <div className="privacy-content">
              <div 
                className="privacy-text"
                dangerouslySetInnerHTML={{ 
                  __html: privacyService.formatPrivacyContent(privacyData) 
                }}
              />
              
              {privacyData.lastUpdated && (
                <div className="privacy-updated">
                  <small>
                    Última actualización: {new Date(privacyData.lastUpdated).toLocaleDateString('es-MX')}
                  </small>
                </div>
              )}
            </div>
          )}
        </div>

        {showAcceptButton && (
          <div className="privacy-modal-footer">
            <button 
              className="privacy-button secondary" 
              onClick={handleCancel}
              type="button"
            >
              Cancelar
            </button>
            <button 
              className="privacy-button primary" 
              onClick={handleAccept}
              disabled={loading}
              type="button"
            >
              Acepto los Términos
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrivacyNoticeModal;
